module.exports = __webpack_public_path__ + "static/media/arrow.c6bbbbe4.svg";